<template>
  <span
    ref="el"
    class="cursor-pointer underline decoration-dotted decoration-1 underline-offset-4 select-none"
    :style="{ color: current.color, transition: 'color 0.3s ease' }"
    @click="cycle"
    title="Click to explore"
  >{{ current.text }}</span>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import gsap from 'gsap'

const props = defineProps<{
  options: Array<{ text: string; color: string }>
}>()

const el = ref<HTMLSpanElement | null>(null)
const index = ref(0)
const current = computed(() => props.options[index.value])

function cycle() {
  if (!el.value) return
  gsap.to(el.value, {
    opacity: 0,
    duration: 0.1,
    onComplete: () => {
      index.value = (index.value + 1) % props.options.length
      gsap.to(el.value, { opacity: 1, duration: 0.2 })
    },
  })
}
</script>
